import { Auth0Provider } from "@auth0/auth0-react";

import React, { useState, useEffect } from "react";

export default function AuthProvider({ children, router }) {
	return (
		<Auth0Provider
			domain={process.env.AUTH0_DOMAIN}
			clientId={process.env.AUTH0_CLIENT_ID}
			authorizationParams={{
				audience: process.env.AUTH0_AUDIENCE,
				redirect_uri: process.env.AUTH0_REDIRECT_URI,
			}}
			cookieDomain={process.env.AUTH0_COOKIE_DOMAIN}
			onRedirectCallback={(appState, user) => {
				console.log(user);
				if (appState?.prevPath) {
					router.push(appState?.prevPath);
				}
			}}
		>
			{children}
		</Auth0Provider>
	);
}
/**
 * , https://platform-web-app-deploy.azurewebsites.net, https://platform-web-api-staging.azurewebsites.net, https://aapl-staging.us.auth0.com
 */
